import { supplierIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const addProductsToSupplier = {
  name: "addProductsToSupplier" as const,
  input: z.object({
    supplierIds: z.array(supplierIdFormat.schema),
    productIds: z.array(productIdFormat.schema),
  }),
  output: z.object({ addedCount: z.number().int() }),
};
